<template>
  <section class="orders">
    <main :class="{ 'expand-main': isMenuCollapse, 'main': !fromClient }">
      <div class="m-2">
        <div
          class="row mb-2 justify-content-right"
          v-if="!hasPermissions('adminClients')"
        >
          <div class="col-12 bg-light pb-2" v-if="client_id == undefined">
            <div class="px-4">
              <div
                id="neworder"
                class="top-area-opp mt-2 float-right d-none d-sm-block"
              >
                <button
                  class="w-100 btn btn-sm btn-primary themed-button effect-btn"
                  @click="addOrder"
                  type="submit"
                >
                  <i class="icon-plus1"></i>
                  {{ $t("lang.button.neworder") }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="border-bottom border-grey">
          <!-- :tabs="hasPermissions('isAdminAgency') ? adminTabs : tabs" -->
          <div class="px-4 d-inline">
            <Tabs
              :tabSelected="typelist"
              :tabs="selectTabs"
              @change="loadOrders($event)"
            />
          </div>
          <!-- <div class="px-4 d-inline">
            <span
              type="button"
              class="p-0 it-tabs pb-2"
              :class="orderStatus == 1 ? 'active border-primary' : ''"
              @click="loadOrders(1)"
            >
              {{ $t("lang.button.all") }}
            </span>
          </div>
          <div class="ml-2 d-inline">
            <span
              type="button"
              class="p-0 it-tabs pb-2"
              :class="orderStatus == 2 ? 'active border-primary' : ''"
              @click="loadOrders(2)"
            >
              {{ this.$t("lang.targets.stopped") }}
            </span>
          </div>
          <div class="ml-4 d-inline">
            <span
              type="button"
              class="p-0 it-tabs pb-2"
              :class="orderStatus == 5 ? 'active border-primary' : ''"
              @click="loadOrders(5)"
            >
              {{ $t("lang.onBoarding.archived_orders") }}
            </span>
          </div> -->
        </div>

        <!-- Show table (list orders) -->
        <div>
          <div class="row col-4 d-flex" v-if="currentUser.role_id == 1 && false">
            <div class="ml-3 mt-2">
              <FilterSystem
                class=""
                :columns="filterColumn"
                :reset="resetFilterSystem"
                :filterSystem="filterSystem"
                :sort="sort"
                :dir="dir"
                :key="keyFilter"
                :filterOldQuery="oldQuery"
                @callApi="filter($event)"
              />
            </div>
          </div>

          <LoadingSpinner v-if="loading" />
          <Table
            v-if="!loading && !showEmptyImage"
            class="mx-2"
            :headers="headers"
            :cols="cols"
            :data="orders"
            :checkbox="false"
            :notselect="true"
            :model="model"
            :fieldsLoading="fieldsLoading"
            :key="captainkey"
            @editOrder="editOrder"
            @openTarget="openTarget"
            @openClient="openClient"
          >
          </Table>
          <div class="row">
            <div class="col">
              <div class="float-left">
                <Pagination
                  v-if="!loading && !showEmptyImage"
                  :total="total"
                  :totalpage="this.orders.length"
                  :model="model"
                  :limit="true"
                  :color="'primary'"
                  @changePage="changePage"
                  key="paginationkey"
                ></Pagination>
              </div>
            </div>
          </div>

          <div class="w-100 text-center pt-5" v-if="showEmptyImage">
            <img src="@/assets/images/launch.png" class="" />
            <div class="mt-3 text-center">
              <span class="font-weight-light ft-1-5 text-center text-secondary">{{
                $t("lang.label.therearenoordersatthemoment")
              }}</span>
            </div>
            <div class="mt-3 text-center"
                    v-if="!hasPermissions('adminClients')">
              <div class="mr-2 d-inline">
                <button
                  id="newcampaign"
                  class="btn btn-sm btn-primary themed-button effect-btn"
                  @click="addOrder"
                  type="submit"
                >
                  <i class="icon-plus1"></i>
                  {{ $t("lang.button.neworder") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { targetsService, usersService } from "@/_services";
import Table from "@/components/Common/Table.vue";
import Tabs from "@/components/Common/Tabs.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import FilterSystem from "@/components/FilterSystem.vue";
import Pagination from "@/components/Common/Pagination.vue";

export default {
  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
    }),
    selectTabs(){
      if(this.hasPermissions('isAdminAgency')){
        return this.adminTabs
      }
      if(this.hasPermissions('billing')){
        return this.billingTabs
      }
      return this.tabs
    }
  },

  data() {
    return {
      fieldsLoading: true,
      archived: false,
      total: 0,
      resetFilterSystem: false,
      paginationkey: 9900,
      sort: "",
      dir: "",
      keyFilter: 1,
      filterSystem: {},
      oldQuery: "  ",
      listStatus: [
        {
          id: 2,
          name: this.$t("lang.label.nonverified"),
        },
        {
          id: 1,
          name: this.$t("lang.label.verified"),
        },
      ],
      orderStatus: 10,
      loading: true,
      typelist: 10,
      filterColumn: [],
      mainTabs: {
        1: {
          id: 1,
          name: "Parameters",
        },
        2: {
          id: 2,
          name: "History",
        },
      },
      adminTabs: {
        1: {
          id: 10,
          name: this.$t("lang.button.all"),
        },
        2: {
          id: 2,
          name: this.$t("lang.targets.stopped"),
        },
        3: {
          id: 5,
          name: this.$t("lang.onBoarding.archived_orders"),
        },
        4: {
          id: 1,
          name: this.$t("lang.targets.active"),
        },
        5: {
          id: 6,
          name: this.$t("lang.label.verified"),
        },
        6: {
          id: 7,
          name: this.$t("lang.label.unverified"),
        },
        7: {
          id: 8,
          name: this.$t("lang.refuse.tab"),
        },
      },
      tabs: {
        1: {
          id: 10,
          name: this.$t("lang.button.all"),
        },
        2: {
          id: 2,
          name: this.$t("lang.targets.stopped"),
        },
        3: {
          id: 5,
          name: this.$t("lang.onBoarding.archived_orders"),
        },
        4: {
          id: 1,
          name: this.$t("lang.targets.active"),
        },
      },
      billingTabs: {
        1: {
          id: 10,
          name: this.$t("lang.button.all"),
        },
        2: {
          id: 2,
          name: this.$t("lang.targets.stopped"),
        },
        3: {
          id: 5,
          name: this.$t("lang.onBoarding.archived_orders"),
        },
        4: {
          id: 1,
          name: this.$t("lang.targets.active"),
        },
        5: {
          id: 3,
          name: this.$t("lang.label.active"),
        },
      },
      orders: [],
      showEmptyImage: false,

      captainkey: 112000,
      model: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 25,
        currentPage: 1,
      },
      cols: [
        [
          {
            value_label: "target_name",
            value_emit: "id",
            class: "text-primary",
            type: "emit",
            emit: "openTarget",
            badges: [
               {
                badge_if: "stats",
                badge_value: "2",
                badge_class: "badge badge-danger text-white",
                badge_label: this.$t("lang.label.nonverified"),
              },
              {
                badge_if: "stats",
                badge_value: "1",
                badge_class: "badge badge-success text-white",
                badge_label: this.$t("lang.label.verified"),
              },
              {
                badge_if: "stats",
                badge_value: "0",
                badge_class: "badge badge-secondary text-white",
                badge_label: this.$t("lang.label.unverified"),
              },
            ],
          },
        ],
        [
          {
            label: this.$t("lang.targets.active"),
            value_emit: "id",
            value: "target_status_id",
            value_if: 1,
            class: "badge badge-primary text-white",
            type: "emit",
            icon: "",
            emit: "editOrder",
          },
          {
            label: this.$t("lang.targets.stopped"),
            value_emit: "id",
            value: "target_status_id",
            value_if: 2,
            class: "badge badge-danger text-white",
            type: "emit",
            icon: "",
            emit: "editOrder",
          },
          {
            label: this.$t("lang.targets.pending"),
            value_emit: "id",
            value: "target_status_id",
            value_if: 3,
            class: "badge badge-secondary text-white",
            type: "emit",
            icon: "",
            emit: "editOrder",
          },
          {
            label: this.$t("lang.targets.running"),
            value_emit: "id",
            value: "target_status_id",
            value_if: 4,
            class: "badge badge-success text-white",
            type: "emit",
            icon: "",
            emit: "editOrder",
          },
          {
            label: this.$t("lang.targets.archived"),
            value_emit: "id",
            value: "target_status_id",
            value_if: 5,
            class: "badge badge-warning text-white",
            type: "emit",
            icon: "",
            emit: "editOrder",
          },
        ],
        [
          {
            value: "name",
          },
        ],
        [
          {
            value_label: "client_name",
            value_emit: "client_id",
            class: "text-primary",
            type: "emit",
            emit: "openClient",
          },
        ],
        [
          {
            value: "sales",
            loading: "true",
          },
        ],
        [
          {
            value: "warmup_days",
            class: "text-center",
          },
        ],
        [
          {
            type: "progressbar",
            total: "prospectors_total",
            values: [
              {
                total: "prospectors_warmingup",
                class: "warning",
                tooltip: this.$t("lang.general.teamwarmingup"),
                label: this.$t("lang.general.warning_up"),
              },
              {
                total: "prospectors_active",
                class: "success",
                tooltip: this.$t("lang.general.teamwarmingup"),
                label: this.$t("lang.general.ready"),
              },
              {
                total: "prospectors_resting",
                class: "danger",
                tooltip: this.$t("lang.general.teamwarmingup"),
                label: this.$t("lang.general.resting"),
              },
              {
                total: "setting",
                class: "dark",
                tooltip: "Setting up",
                label: this.$t("lang.general.setting_up"),
              },
            ],
          },
        ],
        [
          {
            value: "target_size",
          },
        ],
        [
          {
            value: "contacted",
            loading: "true",
          },
        ],
        [
          {
            value: "appointments",
          },
        ],
        [
          {
            value: "id",
            type: "campaignsBadge",
            loading: "true",
          }
        ] ,
        [
          {
            value: "contactProcess"
          }
        ],
        [
          {
            label: this.$t("lang.orders.open"),
            value_emit: "id",
            class: "text-primary",
            type: "emit",
            icon: "icon-edit",
            emit: "editOrder",
          },
        ],
      ],
     headers: [
        {
          label: this.$t("lang.column.name"),
          percentage: "10.5%",
          class: "overflowhide",
          id:1
        },
        {
          label: this.$t("lang.column.status"),
          percentage: "12.5%",
          class: "overflowhide",
          id:2
        },
        {
          label: this.$t("lang.column.owner"),
          percentage: "12.5%",
          class: "overflowhide",
          id:3
        },
        {
          label: this.$t("lang.column.client"),
          percentage: "12.5%",
          class: "overflowhide",
          id:11
        },
        {
          label: this.$t("lang.label.sales"),
          percentage: "12.5%",
          class: "",
          id:4
        },
        {
          label: "warmup " + this.$t("lang.label.days"),
          percentage: "12.5%",
          class: "overflowhide",
          id:5
        },
        {
          label: this.$t("lang.label.prospectingemails"),
          percentage: "12.5%",
          class: "",
          id:6
        },
        {
          label: this.$t("lang.label.portentialaudiencesize"),
          percentage: "12.5%",
          class: "overflowhide",
          id:7
        },
        {
          label: this.$t("lang.statistics.engaged"),
          percentage: "12.5%",
          class: "overflowhide",
          id:8
        },
        {
          label: this.$t("lang.statistics.generated"),
          percentage: "12.5%",
          class: "overflowhide",
          id:9
        },
        {
          label: this.$t("lang.orders.engaged"),
          percentage: "14.5%",
          class: "",
          id:10,
          permission: "adminClients"
        },
        {
          label: this.$t("lang.orders.meeting"),
          percentage: "12.5%",
          class: "overflowhide",
          id:11,
          permission: "adminClients"
        },
        {
          label: this.$t("lang.label.actions"),
          percentage: "12.5%",
          class: "overflowhide",
          id:12
        },
      ],
    };
  },
  components: {
    Table,
    LoadingSpinner,
    Tabs,
    FilterSystem,
    Pagination,
  },

  created(){
    this.loading = true;
    if(!this.hasPermissions('adminClients')){
      this.headers = this.headers.filter( header => header.id != 5)
      this.cols = this.cols.filter(  col => col[0].value != 'warmup_days')
    }
    this.loading = false;
  },
  mounted() {
    this.removeColumn('adminClients', 5, 'warmup_days')
    this.loadOrders(10);
    this.udpdateHeader(this.$route.name);
    this.setCurrentRouteChild({ child: "" });
    this.filterColumn.push({
      name: "Status",
      type: "list",
      list: this.listStatus,
      field: "tv.status",
    });
  },

  props: {
    client_id: {
      type: Number,
      default: undefined,
    },
    fromClient: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    ...mapActions("headertopbar", {
      setCurrentRoute: "setRoute",
      setCurrentRouteChild: "setRouteChild",
    }),
    udpdateHeader(route) {
      this.setCurrentRoute({ page: route });
    },
    /**
    * Function that remove column from table by role type
    * @author   Claudio
    * @param    {String} permission  Name of permission
    * @param    {Number} header_id   Number that identifier the header
    * @param    {String} col_value   value to identifier column
    * @return   void
    */
    removeColumn(permission,header_id,col_value){
      if(!this.hasPermissions(permission)){
        this.headers = this.headers.filter( h => h.id != header_id)
        this.cols = this.cols.filter(  col => col[0].value != col_value)
      }
    },
    hasPermissions(perm){
      return this.$store.getters['authentication/hasPermissions'](perm)
    },
    loadOrders(order, filter = []) {
      //this.archived = false;
       this.orders = [];
      this.loading = true;
      this.fieldsLoading = true;
      this.showEmptyImage = false;
      this.typelist = order;
      if (this.orderStatus != order) {
        this.model.currentPage = 1;
      }
      let filters = {
        currentPage: this.model.currentPage,
        cantPerPage: this.model.cantPerPage,
        filters: filter.filters ? filter.filters : null,
      };
      this.orderStatus = order;

      //this.showEmptyImage = true;
      let targets = [];
      if (order == 10 || order == 6) {
        targets = [1, 2, 3, 4];
      } else {
        targets = [order];
      }
      let data = {
        client_id: this.client_id,
        target_status_id: targets,
      };

      data.searchFilter = filters;

      // if (filter.filters) {
      //   data.searchFilter = filter;
      // }
      if (order == 3) {
        data.target_status_id = [4];
      }

      if (order == 6) {
        data.verified = true;
        data.target_status_id = [1, 4];
      }
      if (order == 7) {
        data.unverified = true;
        data.target_status_id = [1, 4];
      }
      if (order == 8) {
        data.refused = true;
        data.target_status_id = [1, 2, 3, 4];
      }

      targetsService.getTargetListByClientAndStatus(data).then((response) => {

        if (response !== undefined) {
           this.loading = false;
          this.total = parseInt(response.total);
          if (this.total > 0) {
            this.orders = response.orders;
            this.fieldsLoading = true;
            this.loadMoreInfoTarget();
          } else {
            this.showEmptyImage = true;
          }
        }
      });
    },

    // loadArchivedOrders() {
    //   this.archived = true;
    //   this.loading = true;
    //   this.showEmptyImage = false;
    //   let data = {
    //     client_id: this.client_id,
    //     target_status_id: 5,
    //   };
    //   targetsService.getTargetListByClientAndStatus(data).then((response) => {
    //     if (response !== undefined) {
    //       this.orders = response;
    //       if (this.orders.length == 0) this.showEmptyImage = true;
    //       this.loading = false;
    //     }
    //   });
    // },

    editOrder(index) {
      this.$router.push("/orders/" + index);
    },

    filter(event) {
      this.loadOrders(this.orderStatus, event);
    },

    addOrder(index) {
      this.$router.push("/orders/add");
    },
    openTarget(order_id) {
      let url = "/orders/" + order_id;
      window.open(url, "_blank");
    },
    openClient(client_id) {
      console.log('client_id', client_id);
      let url = "/clients/" + client_id;
        window.open(url, "_blank");
    },
    changePage() {
      this.loadOrders(this.orderStatus);
    },
    loadMoreInfoTarget() {
      let neworders = [];
      let newItem = [];

      this.orders.forEach(async (item) => {

        if (!item.target_size) {
          item.target_size = 0;
        }
        const resp = await usersService.getSales(item.id).then(async (res) => {
          let contacted;
          let allSales = [];
          res.forEach((sale) => {
            if (item.id == sale.target_id) {
              let saleName = "";
              saleName = sale.first_name + " " + sale.last_name;
              allSales.push(saleName);
            }
          });


          const resp2 = await targetsService
            .getContactedOrder(item.id)
            .then((r) => {
              contacted = r.total_contacts;
              newItem = Object.assign({}, item, {
                sales: allSales.join("  -  "),
                contacted: contacted
              });
              neworders.push(newItem);
            });
        });
      });
     // this.loading = true;
      this.orders = neworders;

       setTimeout(() => {
              this.fieldsLoading = false;
              // console.log("Fin Orders");
            }, 5000);
      // this.loading = false;


    },
  },
};
</script>
